import Nav from "./components/Nav";
import { Outlet } from "react-router-dom";
import { Footer } from "flowbite-react";
import FloatingWhatsAppButton from "./components/FloatingWhatsAppButton";
import { getSiteContent, localeRoutes } from "./i18n/siteContent";

function RootLayout({ locale = "en" }) {
    const site = getSiteContent(locale);
    const routes = localeRoutes[locale];

    return (
        <>
            <div className="min-h-screen bg-slate-50">
                <header>
                    <Nav locale={locale} />
                </header>
                <Outlet />
                <FloatingWhatsAppButton locale={locale} />
                <footer>
                    <Footer container className="mx-auto mt-12 max-w-6xl rounded-2xl border border-slate-200 bg-white px-6 py-8">
                        <div className="w-full">
                            <div className="mb-4 flex flex-wrap items-center justify-between gap-4">
                                <p className="text-sm text-slate-700">{site.footer.prompt}</p>
                                <a
                                    href={routes.contact}
                                    className="inline-flex items-center rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-700"
                                >
                                    {site.footer.cta}
                                </a>
                            </div>
                            <Footer.Copyright href="#" by="Maurizio Brioschi" year={new Date().getFullYear()} />
                            <Footer.LinkGroup>
                                <Footer.Link href={routes.home}>{site.nav.home}</Footer.Link>
                                <Footer.Link href={routes.services}>{site.nav.services}</Footer.Link>
                                <Footer.Link href={routes.caseStudies}>{site.nav.caseStudies}</Footer.Link>
                                <Footer.Link href={routes.about}>{site.nav.about}</Footer.Link>
                                <Footer.Link href={routes.contact}>{site.nav.contact}</Footer.Link>
                                <Footer.Link href="/assets/cv/maurizio-brioschi-cv-en.pdf" target="_blank" rel="noopener" download>
                                    {site.footer.cvEn}
                                </Footer.Link>
                                <Footer.Link href="/assets/cv/maurizio-brioschi-cv-it.pdf" target="_blank" rel="noopener" download>
                                    {site.footer.cvIt}
                                </Footer.Link>
                            </Footer.LinkGroup>
                        </div>
                    </Footer>
                </footer>
            </div>
        </>
    );
}

export default RootLayout;
